/* unplugin-vue-components disabled */import { render } from "./BottomTabBar.vue?vue&type=template&id=0660bafa&scoped=true"
import script from "./BottomTabBar.vue?vue&type=script&lang=js"
export * from "./BottomTabBar.vue?vue&type=script&lang=js"

import "./BottomTabBar.vue?vue&type=style&index=0&id=0660bafa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0660bafa"]])

export default __exports__